import firebase from 'firebase/app'

// Initialize Firebase
let config = {
  apiKey: "AIzaSyDY6Ju6OB1RZgx2TQifZm4w8QJlj93xdOM",
  authDomain: "wp-distributor.firebaseapp.com",
  projectId: "wp-distributor",
  storageBucket: "wp-distributor.appspot.com",
  messagingSenderId: "365369321345",
  appId: "1:365369321345:web:bd7bac6bc1184f06266a80",
  measurementId: "G-3QHQ8N31BM"
};
firebase.initializeApp(config)
